import {Stack} from 'shells/layout/stack/stack';
import {AiBadge} from 'shells/summary/ai-badge';
import {Body} from 'shells/typography/body';

import type {ThreadType} from 'nutshell-graphql-types';
import type {GetForm_form_createRules_lead as CreateRulesLeadFragment} from 'nutshell-graphql-types';

import {Rules} from './rules';

interface Props {
    hasAILeadCreation: boolean;
    threadType: ThreadType;
    hasNewColumnLayout: boolean;
    createRules: CreateRulesLeadFragment | null | undefined;
    setCreateRulesSidebar: (value: boolean) => void;
    setShowPhoneRedirectSidebar: (value: boolean) => void;
    redirectPhoneNumber: string | null;
    isEmbedded: boolean;
}

export const LeadCreationRules = (props: Props) => {
    return (
        <Stack spacing={8}>
            {props.hasAILeadCreation && (
                <Stack spacing={8}>
                    <Stack isHorizontal={true} spacing={8} alignItems='center'>
                        <Body isBold={true} color='dark'>
                            Automatically create leads
                        </Body>
                        <AiBadge />
                    </Stack>
                    <Body color='dark'>
                        Uses LLM-powered parsing to extract contacts & company info from email
                        signatures
                    </Body>
                </Stack>
            )}
            <Rules
                createRules={props.createRules}
                setCreateRulesSidebar={props.setCreateRulesSidebar}
                showRedirectNumberSidebar={props.setShowPhoneRedirectSidebar}
                redirectPhoneNumber={
                    props.redirectPhoneNumber ? props.redirectPhoneNumber : undefined
                }
                isEmbedded={props.isEmbedded}
                threadType={props.threadType}
                hasNewColumnLayout={props.hasNewColumnLayout}
            />
        </Stack>
    );
};
